import { ActionMenu, ConfirmationDialog } from '@ijoin/components';
import MoreVertIcon from '@mui/icons-material/MoreVert';
import { IconButton } from '@mui/material';

import { camelCase } from 'lodash';
import { useToggle } from 'usehooks-ts';

type RecordKeepingOrganization = {
  city?: string;
  name: string;
  recordKeeperTypeId?: string;
  RecordKeeperTypes?: { description?: string };
  recordKeepingOrganizationId: string;
  state?: string;
};

export const RkoActionsCell = (props: {
  onDeleted: () => void;
  org: RecordKeepingOrganization;
}) => {
  const [isDeleteOpen, toggleDeleteOpen] = useToggle();

  return (
    <>
      <ActionMenu
        actions={[{ content: 'Delete', onSelect: toggleDeleteOpen }]}
        trigger={
          <IconButton
            data-component='actionsMenu'
            data-testid={`actions-${camelCase(props.org.name)}`}>
            <MoreVertIcon />
          </IconButton>
        }
      />
      <ConfirmationDialog
        confirmationText='DELETE'
        confirmColor='error'
        confirmText='Delete'
        data-testid={`delete-${camelCase(props.org.name)}`}
        isOpen={isDeleteOpen}
        message={`Are you sure you want to delete "${props.org.name}"? This action cannot be undone.`}
        onCancel={toggleDeleteOpen}
        onConfirm={() => {
          toggleDeleteOpen();
          props.onDeleted();
        }}
        title='Delete Record Keeping Organization'
      />
    </>
  );
};
